import useLoginCheck from 'hooks/common/useLoginCheck';
import { deleteSpace } from 'lib/api/place';
import { changeProp, initialize } from 'modules/storeSlice';
import { useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

const usePlan = (storeId, spaceId, length) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const { loading } = useSelector(({ store }) => store);

  const { error, mutate } = useMutation(deleteSpace, {
    onMutate: () => {
      if (!loading.includes(spaceId)) {
        dispatch(changeProp({ key: 'loading', value: [...loading, spaceId] }));
      }
    },
    onError: data => {
      if (data?.response.status === 500) {
        dispatch(
          changeProp({
            key: 'loading',
            value: loading.filter(el => el !== spaceId),
          }),
        );
        dispatch(changeProp({ key: 'error', value: true }));
      }
    },
    onSuccess: () => {
      dispatch(
        changeProp({
          key: 'loading',
          value: loading.filter(el => el !== spaceId),
        }),
      );
      queryClient.invalidateQueries('store');
    },
  });

  useLoginCheck(error?.response, () => {
    mutate({ storeId, spaceId });
  });

  useEffect(() => {
    dispatch(initialize('error'));
    dispatch(initialize('loading'));
  }, [dispatch]);

  const onDelete = () => {
    if (length === 1) return;
    mutate({ storeId, spaceId });
  };

  return { onDelete };
};

export default usePlan;
